import * as config from "config";

const EnvironmentBackground = ({ children }) => {
  return <div className={`env-${config.ENVIRONMENT}`}>{children}</div>;
};

export default EnvironmentBackground;
